module.exports = __webpack_public_path__ + "img/ewm1.5ab0ec2d.png";